import type { ChartSettings, ArrowMode, SpinMode } from './types';

export function arrowMarkerId(color: string): string {
  return 'arw_' + String(color).replace(/[^a-zA-Z0-9]/g, '');
}

export interface ResolvedWireStyle {
  style: string; color: string; width: number; dash: string;
  arrow: ArrowMode; markerEndColor: string | null; markerStartColor: string | null;
}

export function resolveWireStyle(
  override: Partial<{ color: string; width: number; dash: string; arrow: ArrowMode }> | undefined,
  settings: ChartSettings,
): ResolvedWireStyle {
  const o = override || {};
  const color = o.color || settings.wireColor;
  const width = o.width != null ? o.width : settings.wireWidth;
  const dash = o.dash != null && o.dash !== '' ? o.dash : settings.wireDash;
  const arrow = o.arrow || settings.wireArrow;
  let style = `stroke:${color};stroke-width:${width}`;
  if (dash) style += `;stroke-dasharray:${dash}`;
  const markerEndColor = arrow === 'end' || arrow === 'both' ? color : null;
  const markerStartColor = arrow === 'start' || arrow === 'both' ? color : null;
  return { style, color, width, dash, arrow, markerEndColor, markerStartColor };
}

export interface ResolvedRingStyle {
  style: string; color: string; width: number; dash: string;
  spin: SpinMode; speed: number; animated: boolean;
}

export function resolveRingStyle(
  override: Partial<{ ringColor: string; color: string; ringWidth: number; ringDash: string; ringSpin: SpinMode; ringSpeed: number }> | undefined,
  settings: ChartSettings,
  defaultColor: string,
): ResolvedRingStyle {
  const o = override || {};
  const color = o.ringColor || o.color || defaultColor;
  const width = o.ringWidth != null ? o.ringWidth : settings.ringWidth;
  const dash = o.ringDash || settings.ringDash;
  const spin = o.ringSpin || settings.ringSpin;
  const speed = o.ringSpeed != null ? o.ringSpeed : settings.ringSpeed;
  let style = `stroke:${color};stroke-width:${width};stroke-dasharray:${dash}`;
  const animated = !(spin === 'off' || !settings.animate);
  style += animated
    ? `;animation-duration:${Math.max(1, speed)}s;animation-direction:${spin}`
    : ';animation:none';
  return { style, color, width, dash, spin, speed, animated };
}
